import React, { FC, useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { SimpleBar } from '../../../../../../ReactSharedScripts/components/SimpleBar/SimpleBarComponent';
import './styles/simplebar.css';
import debounce from 'lodash/debounce';
import defer from 'lodash/defer';
import { isNull } from '../../../../../../ReactSharedScripts/predicates/type';

const getTrackElement = () => {
	return document.querySelector('.app__body .simplebar-track.horizontal') as HTMLElement;
};

type ListHorizontalScrollProps = {
	className?: string;
	classNameContent?: string;
};

export const ListHorizontalScroll: FC<React.PropsWithChildren<ListHorizontalScrollProps>> = ({
	children,
	className,
	classNameContent,
}) => {
	const hrTrackRef = useRef<HTMLElement | null>(null);
	const hrScrollSectionRef = useRef<HTMLDivElement>();

	const updateHrScroll = useCallback(() => {
		if (isNull(hrTrackRef.current) || isNull(hrScrollSectionRef.current)) return;

		const boundingClientRect = hrScrollSectionRef.current!.getBoundingClientRect();
		hrTrackRef.current!.style.width = `${boundingClientRect.width}px`;
		hrTrackRef.current!.style.left = `${boundingClientRect.left}px`;
		//scrollBarInstanceRef.current!.recalculate();
	}, []);

	const initHrScroll = useCallback(() => {
		if (!hrScrollSectionRef.current) return;

		hrTrackRef.current = getTrackElement();

		const resizeObserver = new ResizeObserver(debounce(updateHrScroll, 300));
		resizeObserver.observe(hrScrollSectionRef.current as HTMLElement);

		defer(() => {
			updateHrScroll();
		});
	}, [updateHrScroll]);

	const resetSyncState = useCallback(() => {
		hrScrollSectionRef.current = null;
		hrTrackRef.current = null;
	}, []);

	const componentClasses = classNames(classes.listPageHorizontalScroll, className);
	const contentClasses = classNames(classes.scrollContent, classNameContent);

	useEffect(() => {
		initHrScroll();

		return () => {
			resetSyncState();
		};
	}, [initHrScroll, resetSyncState]);

	return (
		<SimpleBar
			ref={hrScrollSectionRef}
			className={componentClasses}
			classNameInner={contentClasses}
		>
			{children}
		</SimpleBar>
	);
};
